module.exports = __webpack_public_path__ + "images/Addempl-2x.png";


//////////////////
// WEBPACK FOOTER
// ./images/Addempl-2x.png
// module id = 1106
// module chunks = 1